var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.07 33.334.172-11.355c1.032-.086.946.774 1.032 1.806.086.774.344 5.248.517 9.549h10.924c.172-4.215.43-8.689.516-9.549.086-1.032 0-1.892 1.033-1.806l.258 11.355h1.892l.344-14.28c0-1.032-.688-1.892-1.72-1.978l-6.022-.86c-.344-.173-1.032-.689-1.032-2.151 0-1.032.688-3.785.946-5.85 0-1.548-1.634-1.548-1.634-1.548s-1.634 0-1.634 1.462c.258 2.15.946 4.818.946 5.85 0 1.462-.689 1.978-1.033 2.15l-6.021.86c-1.032.173-1.72 1.033-1.72 1.98l.344 14.365h1.892Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.623781ca6795d6b376dd7c869f3a1365.svg";
export { ForwardRef as ReactComponent };